import React, { Fragment, useContext } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Image from 'next/image';
import { CrossIcon, Warning } from 'assets/img';
import { setCookies } from 'utils/cookies/cookieHandler';
import { StoreContext } from 'pages/_app';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';

function UncateringRedirectModal({ visible, setModal }) {
  const store = useContext(StoreContext);
  const userStore = toJS(store?.userStore);
  const { employeeID, uncateringEmpID, currentUser } = userStore;
  const closeModal = () => {
    setModal(false);
    setTimeout(() => {
      document.documentElement.removeAttribute('style');
    }, 0);
  };

  const handleUserAccountLogin = () => {
    setCookies(employeeID, currentUser);
    setCookies(uncateringEmpID, currentUser);
    window.location.href = process?.env?.NEXT_PUBLIC_APP_UNCATERING_APP_URL;
  };
  const goToUncatering = () => {
    closeModal();
    handleUserAccountLogin();
  };

  return (
    <Transition appear show={visible} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-0 text-left md:items-center md:p-4 md:text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <Dialog.Panel className="flex flex-col items-start gap-8 bg-white pt-2 px-4 pb-16 rounded-t-3xl w-full text-left align-middle shadow-xl transition-all md:items-end md:gap-2 md:py-2 md:px-6 md:pb-14 md:rounded-lg md:w-[90%] md:max-w-[445px]">
                <div className="flex justify-end items-center gap-2 self-stretch">
                  <button
                    type="button"
                    onClick={closeModal}
                    className="flex w-[44px] h-[44px] px-[3px] py-[6px] flex-col justify-center items-center gap-[10px]">
                    <Image src={CrossIcon} alt="cross-icon" width={16} height={16} />
                  </button>
                </div>

                <div className="flex flex-col items-start gap-6 self-stretch">
                  <div className="flex flex-col w-full content-center">
                    <Image
                      src={Warning}
                      alt="warning-icon"
                      className="object-contain"
                      width={'50px'}
                      height={'50px'}
                    />
                  </div>

                  <Dialog.Title
                    as="h3"
                    className="font-inter-semibold text-[24px] leading-[36px] text-[#2D3958]">
                    You’re probably in the wrong place!
                  </Dialog.Title>

                  <p className="font-inter text-[16px] leading-[24px] font-normal text-[#2D3958]">
                    You already have an account as part of a meal plan on our Uncatering service.
                  </p>

                  <span className="font-inter text-[16px] leading-[24px] font-normal text-[#2D3958]">
                    You already have an account as part of a meal plan on our Uncatering service.
                    You are about to sign in to the marketplace. Here, you can place{' '}
                    <small className="font-inter-medium text-[16px] leading-[24px] font-normal text-[#2D3958]">
                      large catering orders and are required to pay directly for these orders.
                    </small>{' '}
                    If you want to place an order through your meal plan, go to Uncatering instead.
                  </span>

                  <div className="flex flex-col items-center gap-6 w-full">
                    <button
                      type="button"
                      onClick={goToUncatering}
                      className="flex h-12 min-w-[98px] px-4 py-2 justify-center items-center gap-2 w-full rounded-full bg-[#575BE8] text-white">
                      Go to Uncatering
                    </button>

                    <button
                      type="button"
                      onClick={closeModal}
                      className="flex h-11 px-2 py-2 border justify-center items-center gap-2 rounded-full text-[#575BE8] border-[#575BE8] font-inter text-[14px] leading-[21px] w-full">
                      Continue to Marketplace
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default observer(UncateringRedirectModal);
